/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestSellerConcessions
 */
export interface RequestSellerConcessions {
}

/**
 * Check if a given object implements the RequestSellerConcessions interface.
 */
export function instanceOfRequestSellerConcessions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RequestSellerConcessionsFromJSON(json: any): RequestSellerConcessions {
    return RequestSellerConcessionsFromJSONTyped(json, false);
}

export function RequestSellerConcessionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestSellerConcessions {
    return json;
}

export function RequestSellerConcessionsToJSON(value?: RequestSellerConcessions | null): any {
    return value;
}

